<div class="table-container">
  <div #columnFilterButton>
    <app-multi-select
      [isVersionImpaired]="true"
      [dropdownWidth]="columnFilterButton.offsetWidth - 2"
      [options]="pcColumnsFilter"
      (choose)="changeColumnFilter($event)"
      [overlayPosition]="columnSettingOverlayPosition"
      (isOpenDropDownChanged)="activeColumnSetting = $event"
      [dropdownMaxHeight]="400"
    >
      <div class="center">
        <app-button-icon
          [iconName]="activeColumnSetting ? icons.Close : icons.BigTriangleDown"
          [isActive]="activeColumnSetting"
          [classSize]="'medium-impaired'"
          buttonName="{{ 'VERSION_VISUALLY_IMPAIRED.VISIBILITY_SETTING' | translate }}"
        ></app-button-icon>
      </div>
    </app-multi-select>
  </div>

  <div class="view">
    <div class="wrapper">
      <table class="table">
        <thead>
          <tr>
            <ng-container *ngIf="staticColumns && staticColumns.length > 0">
              <th class="first-col sticky-col h3-impaired-dark header-text">
                {{ staticColumns[0].title }}
              </th>

              <th
                (click)="changeSorting(staticColumns[1].name)"
                [ngClass]="{
                  'number-text': staticColumns[1].type === 'NUMBER' || staticColumns[1].type === 'numeric' || staticColumns[1].type === 'INTEGER'
                }"
                class="second-col sticky-col h3-impaired-dark header-text"
              >
                <div class="table-title-container">
                  {{ staticColumns[1].title }}
                  <app-impaired-icon
                    *ngIf="sorting.type === staticColumns[1].name"
                    [invertColor]="true"
                    [iconName]="sorting.value === 'ASC' ? icons.ImpairedDown : icons.ImpairedUp"
                  ></app-impaired-icon>
                </div>
              </th>
            </ng-container>

            <ng-container *ngFor="let column of pcColumnsFilter">
              <th
                (click)="changeSorting(column.name)"
                [ngClass]="{ 'number-text': column.isNumber }"
                *ngIf="column.isSelected"
                class="h3-impaired-dark header-text header-text-dynamic"
              >
                <div class="table-title-container">
                  {{ column.title }}
                  <app-impaired-icon
                    *ngIf="sorting.type === column.name"
                    [invertColor]="true"
                    [iconName]="sorting.value === 'ASC' ? icons.ImpairedDown : icons.ImpairedUp"
                  ></app-impaired-icon>
                </div>
              </th>
            </ng-container>
          </tr>
        </thead>
        <tbody *ngLet="fileData$ | async as allFilesData">
          <tr *ngIf="formObject" [formGroup]="formObject">
            <ng-container *ngIf="staticColumns && staticColumns.length > 0">
              <td class="first-col sticky-col text-content">
                <!--                <input (keyup.enter)="changeCriteria()" class="body1-impaired search-input" [formControlName]="staticColumns[0].name"  placeholder="{{ 'DATA.TABLE_FILTER.SEARCH' | translate }}" />-->
              </td>
              <td class="second-col sticky-col text-content">
                <input
                  (keyup.enter)="changeCriteria()"
                  class="sticky-col body1-impaired search-input"
                  [formControlName]="staticColumns[1].name"
                  placeholder="{{ 'DATA.TABLE_FILTER.SEARCH' | translate }}"
                />
              </td>
              <ng-container *ngFor="let column of pcColumnsFilter">
                <td *ngIf="column.isSelected" class="text-content-dynamic">
                  <input
                    (keyup.enter)="changeCriteria()"
                    class="body1-impaired search-input"
                    [formControlName]="column.name"
                    placeholder="{{ 'DATA.TABLE_FILTER.SEARCH' | translate }}"
                  />
                </td>
              </ng-container>
            </ng-container>
          </tr>

          <tr class="row" (click)="goItem(data)" *ngFor="let data of currentData">
            <ng-container *ngIf="staticColumns && staticColumns.length > 0 && data" >
              <td class="first-col sticky-col body1-impaired text-content">
                {{ data[staticColumns[0].name] }}
              </td>

              <td
                [ngClass]="{
                  'number-text': staticColumns[1].type === 'NUMBER' || staticColumns[1].type === 'numeric' || staticColumns[1].type === 'INTEGER'
                }"
                class="second-col sticky-col body1-impaired text-content"
              >
                {{ data[staticColumns[1].name] }}
              </td>
            </ng-container>
            <ng-container *ngFor="let column of pcColumnsFilter">
              <td [ngClass]="{ 'number-text': column.isNumber }"
                  *ngIf="column.isSelected"
                  class="body1-impaired text-content-dynamic">
                {{ getColumnValue(data, column.name, column.type, allFilesData) }}
              </td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>

    <app-impaired-pagination
      #paginator
      [hasShowAll]="false"
      (paginatorChanged)="paginatorChanged($event)"
      [allCount]="(allCatalogCount$ | async) ?? 0"
    ></app-impaired-pagination>
  </div>
</div>
